import {Component, HostBinding, input} from '@angular/core';

@Component({
  selector: 'homey-page-subtitle',
  standalone: true,
  imports: [],
  templateUrl: './page-subtitle.component.html',
  styleUrl: './page-subtitle.component.scss'
})
export class PageSubtitleComponent {
  @HostBinding('class') public readonly class = 'block';
  public readonly title = input.required<string>();
  public readonly subtitle = input<string>();
}
